class QhRelatorioLinha {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.idFuncionario = dados ? dados.idFuncionario : null;
    this.idTipoFuncao = dados ? dados.idTipoFuncao : null;
    this.numeroRegistro = dados ? dados.numeroRegistro : null;
    this.nome = dados ? dados.nome : null;
    this.funcao = dados ? dados.funcao : null;
    this.totalPrev = dados && dados.totalPrev != null ? dados.totalPrev : 0;
    this.totRecesso = dados && dados.totRecesso != null ? dados.totRecesso : 0;
    this.totalExtra = dados && dados.totalExtra != null ? dados.totalExtra : 0;
    this.saldo = dados && dados.saldo != null ? dados.saldo : 0;
  }
}
export default QhRelatorioLinha;
